import { Observable, fromEvent, merge } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CookieFirstWindowEvent, isCookieCategories, isCookieServices } from '../types';
import { CookieBannerEvents, CookieFirstEvents } from '../actions';

export function cookieBannerInitializationEpic(): Observable<any> {
    return merge(
        /**
         * Listen for the Cookie First initialization events.
         */
        fromEvent(window, CookieFirstEvents.INITIALIZED).pipe(map(() => ({ type: CookieBannerEvents.INITIALIZED }))),

        /**
         * Listen for the Cookie First loaded events.
         * This will emit a list of categories that CookieFirst has detected.
         */
        fromEvent(window, CookieFirstEvents.LOADED).pipe(
            map((event) => {
                const categories = (event as CookieFirstWindowEvent)?.detail || {};

                if (typeof categories !== 'object' || !isCookieCategories(categories)) {
                    return null;
                }

                return {
                    type: CookieBannerEvents.LOADED,
                    payload: categories,
                };
            }),
            filter(Boolean),
        ),

        /**
         * Listen for the Cookie First loaded services events.
         * This will emit a list of services that CookieFirst has detected.
         */
        fromEvent(window, CookieFirstEvents.LOADED_SERVICES).pipe(
            map((event) => {
                const services = (event as CookieFirstWindowEvent)?.detail || {};

                if (typeof services !== 'object' || !isCookieServices(services)) {
                    return null;
                }

                return {
                    type: CookieBannerEvents.LOADED_SERVICES,
                    payload: services,
                };
            }),
            filter(Boolean),
        ),

        /**
         * Listen for the Cookie First ready event.
         * This indicates that CookieFirst is fully initialized and ready to use.
         *
         * Note: The reducuer will handle the state update for 'ready',
         * as this event may trigger before the data is fully loaded.
         */
        fromEvent(window, CookieFirstEvents.READY).pipe(map(() => ({ type: CookieBannerEvents.READY }))),
    );
}
